import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Service } from './service.interface';
import { AuthService } from './auth.service';


@Injectable({
    providedIn: 'root'
  })
  
export class DeudaService extends Service {

    constructor(
        private http: HttpClient,
        private authService: AuthService ) {
        super(http, environment.baseURLsage);
    }

    getAllDeudas( id_hermano?: string): Observable<any> {
      const URL = this.baseURL + 'deudas/';
      const params = new Array<string>();
      if (id_hermano) {
        params.push('id_hermano=' +id_hermano);
      }
      return this.get(URL, params);
    }


    async getUrlPhp():Promise<any> {
      return new Promise<any>(resolve=>{
        this.http.get(`${environment.baseURL}urlPHP/`)
        .subscribe((resp:any)=>{
          console.log(resp)
          resolve(resp);
        })
      })
    }

    async getPagoRedsys(importe,hermanoid):Promise<any> {
      return new Promise<any>(resolve=>{
        this.http.get(`${environment.baseURL}pagoRedsys/`+importe+`/`+hermanoid)
        .subscribe((resp:any)=>{
          console.log(resp)
          resolve(resp);
        })
      })
    }

    async getComprobarPagoRedsys(numeroPedido):Promise<any> {
      return new Promise<any>(resolve=>{
        this.http.get(`${environment.baseURL}comprobarPago/`+numeroPedido)
        .subscribe((resp:any)=>{
          console.log(resp)
          resolve(resp);
        })
      })
    }

    async getPagoStripe(importe,token) { 
      return new Promise<any>(resolve=>{
        this.http.get(`${environment.baseURL}pagoStripe/`+importe+`/`+token)
        .subscribe((resp:any)=>{
          console.log(resp)
          resolve(resp);
        })
      })
      }

      async getSandbox_account() { 
        return new Promise<any>(resolve=>{
          this.http.get(`${environment.baseURL}sandbox_account/`)
          .subscribe((resp:any)=>{
            console.log(resp)
            resolve(resp);
          })
        })
      }

        async getClient_ID() { 
          return new Promise<any>(resolve=>{
            this.http.get(`${environment.baseURL}client_ID/`)
            .subscribe((resp:any)=>{
              console.log(resp)
              resolve(resp);
            })
          })
      }

      async getApiKeyStripe() { 
        return new Promise<any>(resolve=>{
          this.http.get(`${environment.baseURL}apiKeyStripe/`)
          .subscribe((resp:any)=>{
            console.log(resp)
            resolve(resp);
          })
        })
    }
    
}